import script from "./RegisterView.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterView.vue?vue&type=script&setup=true&lang=js"

import "./RegisterView.vue?vue&type=style&index=0&id=2d5b4da0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d5b4da0"]])

export default __exports__